import clsx from "clsx";

import { IconProps } from "../Icon";

export const DEFAULT_TRIGGER_ICON_PROPS: IconProps = {
  icon: "icon-lt-more-2-line",
  size: "lg",
  extraClasses: "text-neutral-800",
  cursor: "pointer",
};

export const triggerButtonClasses = (triggerClassName: string | undefined, open: boolean) =>
  clsx(
    triggerClassName,
    "inline-flex items-center justify-center rounded-md",
    "h-10 px-4 py-2",
    "disabled:pointer-events-none disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed",
    "bg-transparent hover:bg-accent hover:text-accent-foreground",
    "ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
    open && "bg-blue-100"
  );
